import { useState } from 'react';

import { AnimatedModal } from 'components/AnimatedModal/AnimatedModal';
import { Button, FileContentsPicker, InputGroup } from 'components/FormComponents';

const FileSubmittionModal = ({
  title,
  description,
  visible,
  onClose = () => {},
  onSubmit = () => {},
}) => {
  const [fileData, setFileData] = useState();

  const handleSubmittion = () => onSubmit(fileData);

  return (
    <AnimatedModal title={title} visible={visible} onClose={onClose}>
      <div>
        <InputGroup>
          <p className="t-small u-margin-bottom--large u-text-centered">{description}</p>
          <FileContentsPicker
            accept={{ 'application/pdf': ['.pdf'], 'application/msword': ['.doc', '.docx'] }}
            onChange={setFileData}
          />
        </InputGroup>
        <div className="d-flex u-width-100 justify-content-end">
          <Button
            type="secondary"
            onClick={onClose}
            className="u-width-100 u-margin-top u-margin-right">
            Cancel
          </Button>
          <Button icon="search" className="u-width-100 u-margin-top" onClick={handleSubmittion}>
            Process Document
          </Button>
        </div>
      </div>
    </AnimatedModal>
  );
};

export default FileSubmittionModal;
